
<div class="flow-tabs-container" :no-content="$slots['content'] ? false : true">
	<!-- @slot Used to display List of Tab component -->
	<div
		class="flow-tabs-wrapper flow-add-scrollbar"
		:type="type"
		:data-sticky="sticky"
		:data-size="size"
	>
		<slot />
	</div>
	<div
		v-if="$slots['content']"
		class="flow-tabs-content-wrapper flow-add-scrollbar"
		:data-size="size"
	>
		<slot name="content" />
	</div>
</div>
